export const paths = {
  authors: '/authors',
  blog: '/blog',
  careerOffers: '/career-offers',
  homepage: '/',
  thankYou: '/thank-you',
} as const;

export const host = 'https://naturaily.com';

export const logoUrl =
  'https://a.storyblok.com/f/275457/70fcca1749/logo_naturaily.png?cv=1729870456307';
